import { ToastContainer } from 'react-toastify';
import AppRouting from './AppRouting';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorBoundariesFallback from './CommonElements/ErrorBoundaries';

function App() {
    return (
        <ErrorBoundary FallbackComponent={ErrorBoundariesFallback}>
            <AppRouting />
            <ToastContainer />
        </ErrorBoundary>
    );
}

export default App;
